@let obs =
  {
    cartEntry: cartEntry$ | async,
    productPrice: productPrice$ | async,
  };

@if (product | sdProductIsAvailable) {
  @if (product.transitPrice || product.stock) {
    @if (obs.cartEntry) {
      <div class="counter-wrapper">
        @if (obs.productPrice) {
          <sd-product-item-counter
            [formControl]="quantityControl"
            [selectedPrice]="obs.productPrice"
            [max]="maxQuantity$ | async"
            [showSaleUnit]="true"
            [loading]="loading$ | async"
            [allowZero]="true"
            [saleQuantity]="obs.cartEntry.quantity"
          ></sd-product-item-counter>
        }
      </div>
    } @else {
      <sd-item-add-to-cart [productIndex]="productIndex" [product]="product"></sd-item-add-to-cart>
    }
  }
} @else {
  <button sdButton type="primary" fullWidth="true" [disabled]="true">товар отсутствует</button>
}
